import type { ReactNode } from 'react';

export type FieldHintProps = {
  hint?: ReactNode;
  error?: string;
};

export function FieldHint({ hint, error }: Readonly<FieldHintProps>): React.JSX.Element | null {
  if (error) return <p className="mt-1.5 text-micro leading-normal text-destructive">{error}</p>;
  if (!hint) return null;
  return <p className="mt-1.5 text-micro leading-normal text-muted-foreground">{hint}</p>;
}
